export const CONTENT_PAGE_PATH = '/content/[...slug]';

export const ssgPaths = [CONTENT_PAGE_PATH];
